var map = {
	"./LunaPark5.jpg": 25,
	"./Melbourne_DFM2-01-svg (1) (2).svg": 26,
	"./car-shot.jpg": 27,
	"./large/car-shot.jpeg": 28,
	"./large/view1.jpeg": 29,
	"./large/view2.jpeg": 30,
	"./logo.jpg": 31,
	"./logo.svg": 32,
	"./logo2.svg": 33,
	"./luna-vector.png": 34,
	"./luna-vector.svg": 35,
	"./map_huge.png": 36,
	"./map_huge_2.png": 37,
	"./thedude.png": 38,
	"./view1.jpg": 39,
	"./view2.jpg": 40
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24;